export function headerFunc() {
  /**
   * 子メニューの表示・非表示
   */
  const headerHasChildNav = document.querySelectorAll( '.l-header-nav li.has-child' ) || false;
  const headerChildBg     = document.querySelector( '.l-header-child__bg' ) || false;

  headerHasChildNav.forEach( item => {
    const link = item.querySelector( '& > a' );
    const child = item.querySelector( '.l-header-child' );

    link.addEventListener( 'click', () => {
      if ( item.classList.contains( 'is-open' ) ) {
        item.classList.remove( 'is-open' );
        $( '.l-header-child' ).hide();
        $( '.l-header-nav li.has-child' ).removeClass( 'is-open' );
        $( child ).stop().fadeOut( 200 );
        $( headerChildBg ).stop().fadeOut( 200 );
      } else {
        item.classList.add( 'is-open' );
        $( '.l-header-child' ).hide();
        $( '.l-header-nav li.has-child' ).removeClass( 'is-open' );
        $( child ).stop().fadeIn( 200 );
        $( headerChildBg ).stop().fadeIn( 200 );
        item.classList.add( 'is-open' );
      }
    } );

    child.querySelector( '.l-header-child__close' ).addEventListener( 'click', () => {
      item.classList.remove( 'is-open' );
      $( child ).stop().fadeOut( 200 );
      $( headerChildBg ).stop().fadeOut( 200 );
    } );
  } );

  if ( headerChildBg ) {
    headerChildBg.addEventListener( 'click', () => {
      $( '.l-header-child' ).stop().fadeOut( 200 );
      $( headerChildBg ).stop().fadeOut( 200 );
      $( '.l-header-nav li.has-child' ).removeClass( 'is-open' );
    } );
  }

  /**
   * スクロール
   */
  let set_position = 0;
  window.addEventListener( 'scroll', ( e ) => {
    let scrollY = window.scrollY;
    const headerBottom = document.querySelector( '.l-header__bottom' );

    if ( headerBottom === null ) return;

    if (window.matchMedia( "(min-width: 1024px)" ).matches) {
      if ( scrollY > 87 ) {
        headerBottom.classList.add( 'is-fixed' );
      } else {
        headerBottom.classList.remove( 'is-fixed' );
      }
    } else {
      if ( scrollY > 50 ) {
        headerBottom.classList.add( 'is-fixed' );
      } else {
        headerBottom.classList.remove( 'is-fixed' );
      }
    }

    // 上か下にスクロールされたか判定する
    if (set_position < document.documentElement.scrollTop) {
      headerBottom.classList.remove( 'is-hide' );
    } else {
      headerBottom.classList.add( 'is-hide' );
    }

    set_position = document.documentElement.scrollTop;
  } );

  /**
   * ハンバーガーメニューの開閉
   */
  const burgerButton = document.querySelector( '.l-header-bottom__burger' );
  const burgerNav = document.querySelector( '.l-header-bottom__nav' );

  if ( burgerButton === null || burgerNav === null ) return;

  burgerButton.addEventListener( 'click', () => {
    $( burgerButton ).toggleClass( 'is-open' );

    if ( burgerButton.classList.contains( 'is-open' ) ) {
      $( 'html' ).css( 'overflow', 'hidden' );
      $( burgerNav ).stop().slideDown( 100 );
    } else {
      $( 'html' ).css( 'overflow', 'visible' );
      $( burgerNav ).stop().slideUp( 100 );
      $( headerChildBg ).stop().fadeOut( 200 );
    }
  } );
}
